import { REDIRECT_PAY_PLUS, REFRESH } from "../types/website.types";

export const setRedirectPayPlus = (redirect) => {
  return {
    type: REDIRECT_PAY_PLUS,
    redirect,
  };
};
export const setRefresh = () => {
  return {
    type: REFRESH,
  };
};
